import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import PeopleIcon from "@mui/icons-material/People";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

import SettingsIcon from "@mui/icons-material/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import PersonIcon from "@mui/icons-material/Person";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";

export const MENU_ITEM = [
  {
    title: "Dashboard",
    redirectTo: "/dashboard",
    iconFilled: DashboardIcon,
    iconOutlined: DashboardOutlinedIcon,
  },
  {
    title: "Building",
    redirectTo: "/building-list",
    iconFilled: ApartmentIcon,
    iconOutlined: ApartmentOutlinedIcon,
  },
  {
    title: "Rental Property",
    redirectTo: "/rental-property-list",
    iconFilled: HomeWorkIcon,
    iconOutlined: HomeWorkOutlinedIcon,
  },
  {
    title: "Tenanty",
    redirectTo: "/tenant-list",
    iconFilled: PeopleIcon,
    iconOutlined: PeopleOutlineOutlinedIcon,
  },
  {
    title: "Invoice",
    redirectTo: "/invoice-list",
    iconFilled: PointOfSaleIcon,
    iconOutlined: PointOfSaleOutlinedIcon,
  },
  {
    title: "Reports",
    redirectTo: "/reports",
    iconFilled: AssessmentIcon,
    iconOutlined: AssessmentOutlinedIcon,
  },
];

export const SETTINGS = [
  {
    title: "Setting",
    redirectTo: "/setting",
    iconFilled: SettingsIcon,
    iconOutlined: SettingsOutlinedIcon,
  },
  {
    title: "Logout",
    action: "logout",
    iconFilled: LogoutIcon,
    iconOutlined: LogoutOutlinedIcon,
  },
];

export const PROFILE = [
  {
    title: "Profile",
    redirectTo: "/profile",
    iconFilled: PersonIcon,
    iconOutlined: PersonOutlinedIcon,
  },
  {
    title: "Account",
    redirectTo: "/account",
    iconFilled: SubscriptionsIcon,
    iconOutlined: SubscriptionsOutlinedIcon,
  },
];
